import { createHelpers } from 'vuex-map-fields';

const { getMemTabField, updateMemTabField } = createHelpers({
    getterType: `getMemTabField`,
    mutationType: `updateMemTabField`,
});


const state = {
    tabs:
        {
            'tab_work': {
                title: 'Обробка',
                is_active: false,
                is_load: false,
                is_count_load : false,
                count : 0,
                disabled : false,
            },
            'tab_resolution': {
                'title': 'Резолюції',
                'is_active': true,
                 is_load: false,
                 is_count_load : false,
                 count : 0,
                disabled : false,
            },
            'tab_monitoring': {
                'title': 'Моніторинг',
                'is_active': false,
                 is_load: false,
                 is_count_load : false,
                 count : 0,
                disabled : false,
            },
            'tab_files': {
                'title': 'Файли',
                'is_active': false,
                 is_load: false,
                 is_count_load : false,
                 count : 0,
                disabled : false,
            },
            'tab_linked': {
                'title': 'Пов\'язані документи',
                'is_active': false,
                 is_load: false,
                 is_count_load : false,
                 count : 0,
                disabled : false,
            },

            'tab_message': {
                'title': 'Повідомлення',
                'is_active': false,
                 is_load: false,
                 is_count_load : false,
                 count : 0,
                disabled : false,
            },

           /* 'edit': {
                'title': 'Редагувати погодження',
                'is_active': false,
                is_load: false,
                disabled: true,
            },*/

        }
}

// actions
const actions = {

    SET_MEM_WORK_TABS( {commit}, data) {
        commit('set_rows', data)
    },

    SET_MEM_LOAD_TAB ({commit},data) {
        commit('set_row_loading', data)
    },

    SET_DIS_TAB ({commit},data) {
        commit('set_row_dis', data)
    },


    SET_MEM_TAB_COUNT ({commit},data) {
        commit('set_row_count', data)
    },

}

const getters = {
    getMemTabField,

    getTabs() {
        return state.tabs;
    },

}

// mutations
const mutations = {
    updateMemTabField,

    set_rows (state,data) {
        state.tabs = {...state.tabs, ...data}
    },

    set_row_dis(state,data) {
        try {
            let tab = state.tabs[data.type];
            tab.disabled = data.flag;
        }
        catch (e) {

        }
    },

    set_row_count(state,data) {
        try {
            let tab = state.tabs[data.type];
            tab.count = data.count;
          /*  if(!tab.is_count_load) {
                tab.title = tab.title.format(data.count);
            }*/
        }
        catch (e) {

        }
    },

    set_row_loading (state,data) {
       try {
           let tab = state.tabs[data.type];
           tab.is_load = data.active;

       }
       catch (e) {

       }
    }


}

export default {

    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
